// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'notepad';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M10.222 17.438H1.688a1.125 1.125 0 0 1-1.125-1.125V1.688A1.125 1.125 0 0 1 1.688.563h14.624a1.125 1.125 0 0 1 1.125 1.125v8.534c0 .298-.118.584-.329.795l-6.091 6.091c-.211.211-.497.33-.795.33z' />
    <path d='M10.688 17.336v-5.523a1.125 1.125 0 0 1 1.124-1.125h5.524M5.063 5.063h9m-9 3.375H9' />
  </g>
);

export const viewBox = '0 0 18 18';
